<template>
  <div class="login_page page">
    <Stage :navNum="1" />
    <span class="login_title" v-if="!$parent.loginStatus"
      >请登录要转移的账号</span
    >
    <span class="login_title" v-else>{{ loginTitle }}</span>
    <div class="login_box" v-if="!$parent.loginStatus">
      <div class="system_box">
        <span>选择账号所在平台：</span>
        <div class="ios_box" @click="$parent.system = 1">
          <i
            :class="`select_icon ${$parent.system == 1 ? 'select_on' : ''}`"
          ></i>
          <i class="ios_icon"></i>
        </div>
        <div class="android_box" @click="$parent.system = 2">
          <i
            :class="`select_icon ${$parent.system == 2 ? 'select_on' : ''}`"
          ></i>
          <i class="android_icon"></i>
        </div>
      </div>
      <div class="phone_box">
        <i class="icon"></i>
        <input
          type="text"
          placeholder="请输入手机号"
          maxlength="11"
          v-model="form.account"
        />
      </div>
      <div class="code_box">
        <i class="icon"></i>
        <input type="text" placeholder="请输入验证码" v-model="code" />
        <div class="send_code" @click="sendMessage" v-if="waitTime == 0">
          获取验证码
        </div>
        <div class="send_code" v-else>{{ waitTime }}s后重新获取</div>
      </div>
      <div class="tip">
        <span
          >提示：使用第三方或游客登录的玩家，请至游戏用户中心绑定手 机号</span
        >
        <i class="tip_icon" @click="$parent.popShow = 'help'"></i>
      </div>
    </div>
    <div class="login_box login_box2" v-else>
      <div class="role_list">
        <div class="role_item" v-for="(item, index) in roleList" :key="index">
          <span>平台：{{ item.system }}</span>
          <span>服务器：{{ item.server }}</span>
          <span>角色名：{{ item.rolename }}</span>
          <span>等级：{{ item.level }}级</span>
        </div>
      </div>
    </div>
    <div class="btn_box">
      <div class="pre_btn" @click="prevStep">上一步</div>
      <div class="login_btn" v-if="!$parent.loginStatus" @click="login">
        登录
      </div>
      <div
        :class="`login_btn ${roleList.length == 0 ? 'no_next' : ''}`"
        @click="nextStep"
        v-else
      >
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import { sendCode, phoneLogin, getRoleList } from '../api/index';
import Stage from './childcomponents/Stage.vue';
export default {
  components: {
    Stage
  },
  data() {
    return {
      loadRoleList: true, //允许触发watch
      timer: '', //倒计时
      loading: false, //登录状态，防抖
      waitTime: 0, //短信等待时间
      code: '',
      form: {
        appkey: 1486458782785,
        action: 'page',
        method: 'send',
        isMobileLogin: 1,
        account: '',
        sign: '',
        annex: ''
      },
      loginTitle: '请确认登录账号下角色信息，转移后账号下所有 角色数据都将转移',
      roleList: []
    };
  },
  computed: {},
  watch: {
    '$parent.loginStatus': function () {
      if (
        this.$parent.loginStatus &&
        this.roleList.length == 0 &&
        this.loadRoleList
      ) {
        let t = new Date().getTime();
        getRoleList({
          appkey: 1486458782785,
          sign: this.$md5(
            t +
              this.$md5(
                1486458782785 + this.$parent.userid + this.$parent.system
              ) +
              'UIwf 8-08e30P)*_)@$e;l23r'
          ),
          userid: this.$parent.userid,
          type: this.$parent.system,
          t: t,
          token: this.$parent.token,
          deviceid: this.$parent.deviceId,
          cert: this.$parent.cert
        }).then((res) => {
          console.log(res);
          if (res.data.data.success) {
            if (res.data.data.list.length != 0) {
              this.roleList = res.data.data.list.map((item) => {
                return {
                  system: this.$parent.system == 1 ? '苹果' : '安卓',
                  server: item.ServerName,
                  rolename: item.Name,
                  level: item.PlayerLevel
                };
              });
            } else {
              this.loginTitle =
                '您登录的账号下没有角色，请点击上一步按钮重新选择账号平台或更换账号登录';
            }
          } else {
            this.$parent.getTip(`查询账号信息失败--${res.data.data.code}`);
          }
        });
      }
    }
  },
  methods: {
    prevStep() {
      if (this.$parent.loginStatus) {
        if (this.roleList.length == 0) {
          clearInterval(this.timer);
          this.waitTime = 0;
          this.form.account = '';
          this.code = '';
          this.$parent.loginStatus = false;
        } else {
          this.$parent.currentPage = 0;
        }
      } else {
        this.$parent.currentPage = 0;
      }
    },
    nextStep() {
      if (this.roleList.length != 0) {
        this.$parent.currentPage = 2;
      }
    },
    sendMessage() {
      let phoneReg = /^1[3-9]\d{9}$/;
      if (phoneReg.test(this.form.account)) {
        this.form.sign = this.$md5(
          this.$md5(this.form.account + 'ACED000574') + 'ACED000574'
        );
        this.waitTime = 60;
        this.timer = setInterval(() => {
          this.waitTime--;
          if (this.waitTime == 0) {
            clearInterval(this.timer);
          }
        }, 1000);
        let c = penc.ps(this.form);
        c.h.appkey = 1486458782785;
        sendCode({ d: c.d }, c.h).then((res) => {
          // console.log(res.headers['zl-ret-nonce']);
          // console.log(res.headers['zl-ret-sign']);
          // console.log(res.config.headers['zl-p-nonce']);
          let b = {
            'zl-ret-nonce': res.headers['zl-ret-nonce'],
            'zl-ret-sign': res.headers['zl-ret-sign'],
            getResponseHeader: function (a) {
              return b[a];
            }
          };
          let dataInfo = penc.de(
            res.data.ret,
            b,
            res.config.headers['zl-p-nonce']
          );
          console.log(dataInfo);
          if (dataInfo.status == 1) {
            //发送成功
          }
        });
      } else {
        this.$parent.getTip('请输入正确的手机号');
      }
    },
    login() {
      let phoneReg = /^1[3-9]\d{9}$/;
      if (phoneReg.test(this.form.account)) {
        if (this.code != '') {
          if (!this.loading) {
            this.loading = true;
            let params = {
              appkey: 1486458782785,
              device: `snsweb${this.getRamNumber()}`,
              code: this.code,
              account: this.form.account,
              action: 'access',
              channel: this.$parent.system == 1 ? 1010031002 : 2010011001,
              ecid: '3010081001',
              version: 'v2',
              tag: 1
            };
            phoneLogin(params).then((res) => {
              if (res.data.status == 1) {
                let info = res.data.data;
                console.log(info, '232323');
                this.$parent.token = info.token;
                this.$parent.user = info.mobile;
                // info.userid = '10006243843';
                this.$parent.userid = info.userid;
                let t = new Date().getTime();
                getRoleList({
                  appkey: 1486458782785,
                  sign: this.$md5(
                    t +
                      this.$md5(
                        1486458782785 + info.userid + this.$parent.system
                      ) +
                      'UIwf 8-08e30P)*_)@$e;l23r'
                  ),
                  userid: info.userid,
                  type: this.$parent.system,
                  t: t,
                  token: this.$parent.token,
                  deviceid: this.$parent.deviceId,
                  cert: this.$parent.cert
                }).then((res) => {
                  console.log(res);
                  if (res.data.data.success) {
                    this.loadRoleList = false; //防止登录成功，list为0，watch二次请求
                    this.$parent.loginStatus = true;
                    this.$parent.cert = encodeURI(res.data.data.info.cert);
                    if (res.data.data.list.length != 0) {
                      this.roleList = res.data.data.list.map((item) => {
                        return {
                          system: this.$parent.system == 1 ? '苹果' : '安卓',
                          server: item.ServerName,
                          rolename: item.Name,
                          level: item.PlayerLevel
                        };
                      });
                    } else {
                      this.loginTitle =
                        '您登录的账号下没有角色，请点击上一步按钮重新选择账号平台或更换账号登录';
                    }
                  } else {
                    this.$parent.getTip(
                      `查询账号信息失败--${res.data.data.code}`
                    );
                  }
                  this.loading = false;
                });
              } else {
                this.$parent.getTip('验证码错误');
                this.loading = false;
              }
            });
          }
        } else {
          this.$parent.getTip('请输入正确的验证码');
        }
      } else {
        this.$parent.getTip('请输入正确的手机号');
      }
    },
    getRamNumber() {
      var result = '';
      for (var i = 0; i < 40; i++) {
        result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
      }
      return result;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.login_page {
  .login_title {
    flex-shrink: 0;
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    color: #1b1919;
    font-size: 0.32rem;
    padding: 0 0.32rem;
    margin-top: 0.46rem;
    margin-bottom: 0.34rem;
  }
  .login_box {
    flex-shrink: 0;
    width: 7.5rem;
    height: 7.2rem;
    background: #feffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.32rem;
    box-sizing: border-box;
    .system_box {
      margin-top: 0.4rem;
      width: 6.85rem;
      height: 1.09rem;
      background: #ecf6ff;
      border-radius: 0.2rem;
      display: flex;
      align-items: center;
      span {
        font-size: 0.28rem;
        color: #656565;
        margin-left: 0.28rem;
        margin-right: 0.52rem;
      }
      .ios_box,
      .android_box {
        display: flex;
        align-items: center;
        .select_icon {
          width: 0.32rem;
          height: 0.32rem;
          background: url('../assets/select.png');
          background-size: 100% 100%;
          margin-right: 0.13rem;
        }
        .select_on {
          background: url('../assets/select_on.png');
          background-size: 100% 100%;
        }
        .ios_icon {
          width: 0.37rem;
          height: 0.46rem;
          background: url('../assets/ios.png');
          background-size: 100% 100%;
        }
        .android_icon {
          width: 0.45rem;
          height: 0.49rem;
          background: url('../assets/android.png');
          background-size: 100% 100%;
        }
      }
      .ios_box {
        margin-right: 0.88rem;
      }
    }
    .code_box,
    .phone_box {
      width: 6.87rem;
      height: 0.9rem;
      background: #feffff;
      border: 0.02rem solid #dddede;
      border-radius: 0.2rem;
      display: flex;
      margin-top: 0.32rem;
      .icon {
        flex-shrink: 0;
        display: block;
        width: 1.07rem;
        height: 0.9rem;
        background: #dddede;
        border: 0.02rem solid #dddede;
        border-radius: 0.2rem 0 0 0.2rem;
      }
      input {
        width: 100%;
        height: 100%;
        outline: none;
        border: none;
        border-radius: 0 0.2rem 0.2rem 0;
        padding: 0 0.46rem;
        font-size: 0.28rem;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #bababa;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #bababa;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #bababa;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #bababa;
      }
      .send_code {
        flex-shrink: 0;
        width: 2rem;
        height: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.28rem;
        color: #656565;
      }
    }
    .tip {
      color: #fb6b3c;
      font-size: 0.24rem;
      margin-top: 0.36rem;
      // display: flex;
      // flex-wrap: wrap;
      // align-items: center;
      .tip_icon {
        display: inline-block;
        width: 0.31rem;
        height: 0.31rem;
        background: url('../assets/tip_icon.png');
        background-size: 100% 100%;
        margin-left: 0.1rem;
        transform: translateY(0.04rem);
      }
    }
  }
  .login_box2 {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    .role_list {
      width: 6.85rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .role_item {
        width: 6.85rem;
        height: 2.37rem;
        background: #f1f5f6;
        border-radius: 0.2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-shrink: 0;
        margin-top: 0.42rem;
        span {
          font-weight: 400;
          color: #656565;
          font-size: 0.28rem;
          margin-left: 0.32rem;
          margin-bottom: 0.1rem;
        }
      }
      .role_item:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>